module.exports = __webpack_public_path__ + "img/sm-macbook-pro.704c9830.png";